import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { RytmicColorRampComponent } from 'src/app/Dialogs/RytmicColorRamp/RytmicColorRamp.component';
import { DataService } from 'src/app/Services/Data.service';
import { StrikeActionType, StrikeService } from 'src/app/Services/StrikeService/StrikeService.service';
import { StrikesSumService } from 'src/app/Services/StrikeService/StrikesSumService.service';

@Component({
  selector: 'app-rytmicaction',
  templateUrl: './rytmicaction.component.html',
  styleUrls: ['./rytmicaction.component.css']
})
export class RytmicActionComponent implements OnInit {

  public StrikeActionType = StrikeActionType;
  public dates:dayAction[] = [];
  public canShow:boolean = true;
  constructor(
    public strikeService:StrikeService,
    public strikeSumService:StrikesSumService,
    public dataService:DataService,
    public dialog: MatDialog,
    private route: ActivatedRoute
    ) {

      this.route.queryParams
      .subscribe(params => {
        if(params.showPanel)
        {
          this.canShow = true
           //console.log(params); // { orderby: "price" }
        }

        if(params.signalAmount)
        {
          this.dataService.appSettings.SingalSizeAmount = Number(params.signalAmount);
           //console.log(params); // { orderby: "price" }
        }


      }
    );

    var icount = 0;
    do{
        var tr =  moment().add(icount,"days");
        var currentday = tr.isoWeekday();
        if(currentday!=6&&currentday!=7)
        {
           var formattedDate = tr.format("YYYY/MM/DD");
           var t:dayAction =
           {
              date:formattedDate,
              day:this.dayShort(currentday)
           }
           this.dates.push(t);
        }

        icount++;
    }
    while(this.dates.length<5)

    this.strikeService.actionDayLeft = this.dates[0].date
    this.strikeService.actionDayRight = this.dates[0].date
  }

  public dayShort(day:number)
  {
      switch(day)
      {
        case 1: return "Mo";
        case 2: return "Tu";
        case 3: return "We";
        case 4: return "Th";
        case 5: return "Fr";
      }
  }

  ngOnInit() {
  }

  public onChangeLeft(selectedView)
  {
    this.strikeService.actionTypeLeft = Number(selectedView);
  }

  public onChangeRight(selectedView)
  {
    this.strikeService.actionTypeRight = Number(selectedView);
  }

  public setLeftDay(day:string)
  {
        this.strikeService.actionDayLeft = day
  }

  public setRightDay(day:string)
  {
    this.strikeService.actionDayRight = day
  }

  public active:any;
  openSettingsWindow() {
    if(this.active)
    {
         this.active.close();
    }

    this.active = this.dialog.open(RytmicColorRampComponent, {
      width: 'auto',
      height: 'auto',
      maxHeight: window.innerHeight - 30 + 'px',
      maxWidth: '100vw',
      minWidth: '300px',
    });
  }
}

export interface dayAction
{
  date:string,
  day:string
}
